export default __webpack_public_path__ + "static/media/client8.f70d9c77.png";